import { render, staticRenderFns } from "./MmlLatestPage.vue?vue&type=template&id=2e85af30&scoped=true&"
import script from "./MmlLatestPage.vue?vue&type=script&lang=js&"
export * from "./MmlLatestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e85af30",
  null
  
)

export default component.exports